import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgWoman = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M12 1a7 7 0 0 1 4.95 11.95 1 1 0 0 1-1.414-1.414 5 5 0 1 0-7.071 0A1 1 0 0 1 7.05 12.95 7 7 0 0 1 12 1ZM14.293 14.793a1 1 0 0 1 1.193-.167l.102.065 5.5 4a1 1 0 0 1 .36.492l.033.12.5 2.5a1 1 0 0 1-1.932.506l-.03-.113-.423-2.117-4.493-3.268-2.396 2.396a1 1 0 0 1-1.32.083l-.094-.083-2.397-2.396-4.493 3.268-.422 2.117a1 1 0 0 1-1.061.8l-.116-.015a1 1 0 0 1-.8-1.061l.015-.116.5-2.5a1 1 0 0 1 .297-.533l.096-.08 5.5-4a1 1 0 0 1 1.204.021l.091.08L12 17.086l2.293-2.292Z" />
      <path d="M6.68 5.427c1.097-1.568 2.233-1.956 3.421-1.44.366.16.6.419.84.805l.08.134.317.567c.207.364.358.546.464.598.049.024.11.047.186.071l.175.048.226.052.284.056 1.175.208.407.078c.625.13 1 .254 1.337.46l.499.326c.198.13.364.246.527.37 1.187.9 1.83 1.954 1.554 3.29l-.046.192-1.932-.516c.121-.456-.117-.866-.784-1.372a6.755 6.755 0 0 0-.267-.192l-.567-.374a.741.741 0 0 0-.156-.073l-.164-.052-.217-.055-.432-.092-1.371-.244-.346-.07a8.214 8.214 0 0 1-.151-.034l-.268-.07a3.32 3.32 0 0 1-.55-.211c-.508-.25-.854-.63-1.204-1.204L9.6 6.484l-.357-.635c-.02-.034-.033-.052-.026-.056h.01l-.02-.006c-.185-.05-.335.034-.691.513l-.197.273c-.491.703-.779 1.902-.818 3.59l-.004.344-2-.007c.007-2.24.383-3.928 1.184-5.073Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgWoman)
const Memo = memo(ForwardRef)
export default Memo
